import run_iterable from "workerpool/run_iterable"

// takes a list of [{url, name}, ...] returns a single blob

export default async (filenames, ...args) =>
  run_iterable(["zip", "compress", filenames], ...args)
    .next()
    .then(({ value }) => value)
